<div mat-dialog-title>
  <span class="title dialog-title font-bold" i18n>Удаление аккаунта</span>
  <button mat-button class="mat-icon-button" (click)="dialogRef.close(false)" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content fusePerfectScrollbar>
  <div class="flex flex-col">
    <span i18n
      >Внимание! После удаления аккаунта все данные будут безвозвратно удалены без возможности восстановления. Чтобы
      подтвердить удаление, введите ФИО пользователя ({{ userName }}) в поле ниже и нажмите «Подтвердить
      удаление».</span
    >
    <mat-form-field appearance="outline">
      <input i18n-placeholder matInput required [formControl]="userNameControl" placeholder="ФИО пользователя" />

      <mat-error *ngIf="userNameControl.hasError('required')" i18n>Поле обязательно для заполнения</mat-error>

      <mat-error *ngIf="userNameControl.hasError('fullNameMismatch')" i18n>ФИО не совпадает</mat-error>
    </mat-form-field>
  </div>
</div>

<div mat-dialog-actions class="flex justify-end items-end">
  <button
    i18n
    mat-raised-button
    type="button"
    class="mat-warn"
    [disabled]="userNameControl.invalid"
    (click)="this.dialogRef.close(true)"
    >Подтвердить удаление</button
  >
  <button i18n mat-button (click)="dialogRef.close(false)">ОТМЕНА</button>
</div>
